import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [CommonModule, RouterModule],
  template: `
    <div class="home-container">
      <div class="welcome-section">
        <h1>🧪 Modelo Único de Resultados</h1>
        <!--<p class="welcome-text">Acceso seguro, oportuno y confiable a resultados de laboratorio clínico y patológico.</p>-->
      </div>

      <!--div>
        <div class="bg-blue-50 border-l-4 border-blue-500 p-6 rounded-lg mb-8">
          <h5 class="text-2xl font-bold text-blue-800 mb-2">
           Realiza tu consulta de resultados según:
          </h5>
            <ul class="list-none ml-0">
              <li class="flex items-center mb-2">
                <i class="pi pi-id-card text-blue-600 mr-2"></i>
                Paciente
              </li>
              <li class="flex items-center mb-2">
                <i class="pi pi-map-marker text-blue-600 mr-2"></i>
                Punto de atención
              </li>
              <li class="flex items-center mb-2">
                <i class="pi pi-calendar text-blue-600 mr-2"></i>
                Fecha de validación
              </li>
            </ul>
            <div class="flex items-center mt-4">
              <h4 class="font-semibold text-gray-800 mb-2">¿Cómo empezar?</h4>              
            </div>
           <div class="flex items-center">            
              <i class="pi pi-arrow-up-left text-gray-400 mr-2"></i>
              <span class="text-gray-500">Selecciona una opción del menú para acceder al módulo deseado.</span>              
            </div>
        </div>
      </div-->

      <!--div class="grid grid-cols-2 md:grid-cols-4 gap-4 mt-8">
          <div class="bg-white p-4 rounded-lg shadow-sm border text-center">
            <div class="text-2xl font-bold text-blue-600">1.2K+</div>
            <div class="text-sm text-gray-600">Consultas hoy</div>
          </div>
          <div class="bg-white p-4 rounded-lg shadow-sm border text-center">
            <div class="text-2xl font-bold text-green-600">98.5%</div>
            <div class="text-sm text-gray-600"><i class="pi pi-id-card text-blue-600 mr-2"></i> Por paciente</div>
          </div>
          <div class="bg-white p-4 rounded-lg shadow-sm border text-center">
            <div class="text-2xl font-bold text-purple-600">10%</div>
            <div class="text-sm text-gray-600"><i class="pi pi-map-marker text-blue-600 mr-2"></i>Por punto de atención</div>
          </div>
          <div class="bg-white p-4 rounded-lg shadow-sm border text-center">
            <div class="text-2xl font-bold text-orange-600">2 %</div>
            <div class="text-sm text-gray-600"><i class="pi pi-calendar text-blue-600 mr-2"></i>Fecha de validación</div>
          </div>
        </div-->

      <!--div class="quick-actions">
        <div class="action-card">
          <h3>Manual de Usuario</h3>
          <p>Consulta la documentación completa</p>
          <a routerLink="/handbook" class="btn-primary">Ver Manual</a>
        </div>                      
      </div-->
    </div>
  `,
  styleUrls: ['./home.component.scss']
})
export class HomeComponent {
  constructor() {}
}
